(function(global) {
	"use strict";

	var DOM = BS.DOM;

	var selectors = [];
	var listenerRegistered = false;
	var popupE = null;
	var containerE = null;
	var closeBtn = null;

	// この変数がセットされているかどうかでポップアップが開いているかどうかを判別できる
	var currentOptions = null;

	// selector で設定した要素をクリックしたときにポップアップ
	function listen(selector) {
		selectors.push(selector);

		if (!listenerRegistered) {
			var tid = null;
			window.addEventListener("click", clickHandler);
			window.addEventListener("resize", function() {
				clearTimeout(tid);
				tid = setTimeout(resizeHandler, 100);
			});
			window.addEventListener("keydown", keyHandler);
			listenerRegistered = true;
		}
	}

	function clickHandler(event) {
		if (!popupE) {
			var p = createPopup();
			popupE = p[0];
			containerE = p[1];
			closeBtn = p[2];
			document.body.appendChild(popupE);
		}

		if (event.which !== 1) {
			return;
		}
		if (DOM.closest(containerE, event.target)) {
			return;
		}

		if (DOM.closest(popupE, event.target) || DOM.closest(closeBtn, event.target)) {
			event.preventDefault();
			closePopup();
			return;
		}

		var opener = null;
		var matched = selectors.some(function(s) {
			var el = DOM.closest(s, event.target);
			if (el) {
				opener = el;
				return true;
			} else {
				return false;
			}
		})
		if (matched) {
			event.preventDefault();
			openPopup(opener);
			return;
		}
	}

	function resizeHandler() {
		if (!currentOptions) {
			return;
		}

		var getMaxSize = function(x) {
			var padding = 2 * 10;
			var ratio = 0.6;
			var sp = 375;
			var ep = 1600;
			if (x <= sp) {
				return x - padding;
			} else if (x >= ep) {
				return ratio * x;
			} else {
				var a = ((1 - ratio) * ep - padding) / Math.pow(ep - sp, 2);
				var b = 1 + 2 * sp * a;
				var c = -padding - a * sp * sp;
				return (-a * x * x) + (b * x) + c;
			}
		};
		var maxWidth = getMaxSize(window.innerWidth);
		var maxHeight = getMaxSize(window.innerHeight);

		var width = maxWidth;
		var height = width / currentOptions.aspectRatio;
		if (height > maxHeight) {
			height = maxHeight;
			width = height * currentOptions.aspectRatio;
		}
		width = Math.floor(width);
		height = Math.floor(height);

		containerE.style.width = width + "px";
		containerE.style.height = height + "px";
	}

	function keyHandler(event) {
		if (event.shiftKey || event.ctrlKey || event.altKey || event.metaKey) {
			return;
		}
		if (currentOptions && event.keyCode === 27) {
			// ESC
			closePopup();
		}
	}

	function openPopup(opener) {
		var options = parseOptions(opener);
		currentOptions = options;

		resizeHandler();

		containerE.appendChild(createVideoElement(options.source));
		popupE.classList.add("active");
	}

	function closePopup() {
		popupE.classList.remove("active");
		DOM.empty(containerE);

		currentOptions = null;
	}

	function createPopup() {
		var containerE = DOM.create("div.js-video-popup-container");
		var closeE = DOM.create("button.js-video-popup-close", {type: "button"}, ["閉じる"]);
		var wrapE = DOM.create("div.js-video-popup-wrap", {}, [
			containerE,
			closeE,
		]);
		return [wrapE, containerE, closeE];
	}

	function parseOptions(opener) {
		var options = {
			source: opener.href,
			aspectRatio: 16/9,
		};

		var r = opener.getAttribute("data-aspect-ratio");
		if (r && /^\d+:\d+$/.test(r)) {
			var pair = r.split(":");
			options.aspectRatio = parseInt(pair[0], 10) / parseInt(pair[1], 10);
		}

		return options;
	}

	function createVideoElement(source) {
		var m;
		if ((m = source.match(/\b(?:youtube(?:-nocookie)?[.]com\/(?:watch\/|watch\?v=|embed\/)|youtu[.]be\/)([0-9A-Za-z_-]+)\b/))) {
			return DOM.create("iframe", {
				width: "100%",
				height: "100%",
				src: "https://www.youtube-nocookie.com/embed/" + m[1] + "?rel=0&autoplay=1",
				frameborder: 0,
				allow: "accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture",
				allowfullscreen: true,
			});

		} else if (/[.](?:jpe?g|png|gif|svg|webp)$/.test(source)) {
			return DOM.create("img", {
				src: source,
				style: {
					position: "absolute",
					top: "0",
					left: "0",
					right: "0",
					bottom: "0",
				},
			});

		} else {
			return DOM.create("div", {}, ["Invalid video source"]);
		}
	}

	if (global.env && global.env.autoInitVideoPopup) {
		BS.DOMReady(function() {
			listen(".video-popup");
			listen(".image-popup");
		});
	}

	global.BS = global.BS || {};
	global.BS.UI = global.BS.UI || {};
	global.BS.UI.VideoPopup = {
		listen: listen,
	};

})(this);
